<template>
    <multiselect
        v-model="type"
        :options="typeOptions"
        track-by="key"
        label="value"
        :multiple="false"
        :allowEmpty="false"
        placeholder="Tipo"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange">
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {typeOptions} from '@/constants/consignment-constants';

    export default {
        name: "ConsignmentTypeSelector",
        components: {
            Multiselect
        },
        props: {
            value: String
        },
        data: function () {
            return {
                type: !!this.value ? this.findTypeByKey(this.value) : null
            }
        },
        computed: {
            typeOptions() {
                return typeOptions;
            }
        },
        methods: {
            findTypeByKey(key) {
                return typeOptions.find(type => (type.key === key));
            },
            notifyChange(type) {
                this.$emit('input', type.key);
            }
        },
        watch: {
            value: function () {
                if (!!this.value) {
                    this.type = this.findTypeByKey(this.value);
                }
            }
        }
    }
</script>

<style scoped>

</style>